import { useMutation, useQuery } from "react-query";
import { OrganizationQuestionnaire, ScopeTwoV2 } from "../../../api";
import { useAuth } from "../../../context";

export const scopeTwoV2Keys = {
  purchasedElectricity: () => ["scopeTwoV2PurchasedElectricity"],
  onsiteGeneration: () => ["scopeTwoV2OnsiteGeneration"],
};

// ---------------- Purchased electricity ----------------

export function useGetPurchasedElectricity(params, config) {
  const { callApi } = useAuth();
  return useQuery([...scopeTwoV2Keys.purchasedElectricity(), params.questionnaireId, params.queryParams.page],
    () => callApi(ScopeTwoV2.getPurchasedElectricity, params), config);
}

export function useAddPurchasedElectricity(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, data }) =>
    callApi(ScopeTwoV2.addPurchasedElectricity, { questionnaireId, data }), config);
}

export function useUpdatePurchasedElectricity(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, recordId, data }) =>
    callApi(ScopeTwoV2.updatePurchasedElectricity, { questionnaireId, recordId, data }), config);
}

export function useDeletePurchasedElectricity(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, recordId }) =>
    callApi(ScopeTwoV2.deletePurchasedElectricity, { questionnaireId, recordId }), config);
}

// ---------------- On-site generation ----------------

export function useGetOnsiteGeneration(params, config) {
  const { callApi } = useAuth();
  return useQuery([...scopeTwoV2Keys.onsiteGeneration(), params.questionnaireId, params.queryParams.page],
    () => callApi(ScopeTwoV2.getOnsiteGeneration, params), config);
}

export function useAddOnsiteGeneration(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, data }) =>
    callApi(ScopeTwoV2.addOnsiteGeneration, { questionnaireId, data }), config);
}

export function useUpdateOnsiteGeneration(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, recordId, data }) =>
    callApi(ScopeTwoV2.updateOnsiteGeneration, { questionnaireId, recordId, data }), config);
}

export function useDeleteOnsiteGeneration(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, recordId }) =>
    callApi(ScopeTwoV2.deleteOnsiteGeneration, { questionnaireId, recordId }), config);
}

// ---------------- Engine version override (ESG_ADMIN) ----------------

export function useUpdateScopeTwoVersion(config) {
  const { callApi } = useAuth();
  return useMutation(({ questionnaireId, scopeTwoVersion }) =>
    callApi(OrganizationQuestionnaire.updateScopeTwoVersion, { questionnaireId, scopeTwoVersion }), config);
}
